var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var PropostesEstatCarregatsFilter = /** @class */ (function (_super) {
    __extends(PropostesEstatCarregatsFilter, _super);
    function PropostesEstatCarregatsFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.estat = null;
        _this.fechaInicio = null;
        _this.fechaFin = null;
        _this.labels['estat'] = _this.i18n('Estat');
        _this.labels['fechaInicio'] = _this.i18n('Data inici');
        _this.labels['fechaFin'] = _this.i18n('Data fi');
        return _this;
    }
    return PropostesEstatCarregatsFilter;
}(FilterData));
export { PropostesEstatCarregatsFilter };
